import React, { useState, useEffect, useRef } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
// import * as wjGrid from '@mescius/wijmo.react.grid'
import * as wjcGrid from '@mescius/wijmo.grid'
import * as wjCell from '@mescius/wijmo.grid.cellmaker'
// import { FlexGridPdfConverter, ScaleMode } from '@mescius/wijmo.grid.pdf'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import customContextMenu from '../../wijmo/customContextMenu'
import colElements from '../../wijmo/columnElements'
import editableFlexGridInitialize from '../../wijmo/editableFlexGridInitialize'
import ErrorBoundary from '../ErrorBoundary'
import BootstrapAlert from '../element/BootstrapAlert'

function getLayoutDef (mode, newContractsCV, characters, rights, subCategories, isShopro, showComment) {
  const deleteButtonCol = {
    cssClassAll: 'wj-style-basic',
    width: 80,
    isReadOnly: true,
    align: 'center',
    cellTemplate: wjCell.CellMaker.makeLink({
      text: '削除',
      href: 'javascript:void(0);',
      click: (e, cell) => { newContractsCV.remove(cell.item) },
      attributes: {
        class: 'btn btn-sm ol-theme-primary py-0'
      }
    })
  }
  const rightsDataMap = new wjcGrid.DataMap(
    [{ id: -1, title: '（未設定）' }].concat(rights),
    'id', 'title'
  )
  if (rightsDataMap) {
    rightsDataMap.getDisplayValues = (contract) => {
      const filteredRights = contract.character_id ? rights.filter((right) => right.character_id === contract.character_id) : rights
      return ['（未設定）'].concat(filteredRights.map((right) => right.title))
    }
  }
  const subCategoriesDataMap = new wjcGrid.DataMap(
    [{ id: '', name: '（未設定）' }].concat(subCategories),
    'id', 'name'
  )

  const isViewMode = mode === 'view'
  const isReadOnly = !['register', 'edit'].includes(mode)
  const ldTwoLines = isShopro
    ? [ // ShoPro側列定義
        {
          colspan: 1,
          cells: [
            { ...colElements.xr.contract_id, binding: 'id', header: 'ID', align: 'center', width: 100, rowspan: 2 }
          ]
        },
        {
          colspan: 1,
          cells: [
            { ...colElements.xr.character, align: 'left', width: 250, isReadOnly: true, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input'), rowspan: 2, dataMap: new wjcGrid.DataMap(characters, 'id', 'title'), wordWrap: true }
          ]
        },
        {
          colspan: 1,
          cells: [
            { ...colElements.xr.royality, aggregate: 'Sum', isReadOnly: true, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input') },
            { ...colElements.xr.rate_decimal, width: 100, isReadOnly: true, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input') }
          ]
        },
        {
          colspan: 1,
          cells: [
            { ...colElements.xr.right_id, width: 300, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input'), dataMap: rightsDataMap, align: 'center' },
            { ...colElements.xr.comment, width: 300, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input') }

          ]
        },
        {
          colspan: 1,
          cells: [
            { ...colElements.xr.category, width: 200, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input'), align: 'center' },
            { ...colElements.xr.sub_category_id, width: 200, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input'), dataMap: subCategoriesDataMap, align: 'center' }
          ]
        },
        {
          colspan: 1,
          cells: [
            isReadOnly ? { ...colElements.xr.canceled_at, rowspan: 2 } : { cssClassAll: 'wj-style-basic', width: 0, isReadOnly: true, rowspan: 2 }
          ]
        }
      ]
    : [ // ライセンシー側列定義
        {
          colspan: showComment ? 6 : 5,
          cells: [
            { ...colElements.xr.character, align: 'left', width: 350, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input'), dataMap: new wjcGrid.DataMap(characters, 'id', 'title') },
            showComment ? { ...colElements.xr.comment, width: 350, isReadOnly: true } : null,
            { ...colElements.xr.royality, aggregate: 'Sum', isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input') },
            { ...colElements.xr.rate_decimal, width: 100, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic' + (isViewMode ? '' : '-input') },
            { ...deleteButtonCol, cellTemplate: isReadOnly ? null : deleteButtonCol.cellTemplate },
            isReadOnly ? { ...colElements.xr.canceled_at } : { cssClassAll: 'wj-style-basic', width: 0, isReadOnly: true }
          ].filter((col) => col)
        }
      ]
  return {
    def: ldTwoLines
  }
}

//
export default function XrContractsRegisterGrid (props) {
  const [newContractsCV, setNewContractsCV] = useState(null)
  const [layoutDef, setLayoutDef] = useState(null)
  const [jsonElem] = useState(props.itemsJsonId ? $('#' + props.itemsJsonId) : null)
  const itemsDiffMap = useRef(new Map())

  const diffExist = props.itemsDiff.add.length > 0 || props.itemsDiff.change.length > 0 || props.itemsDiff.delete.length > 0

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'character_title', text: '版権名', type: 'string', isEditable: false },
    { field: 'comment', text: 'メモ', type: 'string', isEditable: false },
    { field: 'royality', text: '使用料', type: 'number', isEditable: false },
    { field: 'rate_decimal', text: '料率', type: 'number', isEditable: false }
  ]

  useEffect(() => {
    // 最初だけ実行

    // 入力項目の名前
    const inputFields = [
      'id', 'character_id', 'comment', 'right_id', 'royality', 'rate',
      'right_id', 'category', 'sub_category_id'
    ]

    const oldItems = props.oldItemsJson.map((oldItem) => {
      oldItem.rate_decimal = oldItem.rate * 0.01
      delete oldItem.rate
      oldItem.parent = 0

      'category,sub_category_id'.split(',').forEach((name) => {
        if (!oldItem[name]) {
          oldItem[name] = ''
        }
      })
      'right_id'.split(',').forEach((name) => {
        if (!oldItem[name]) {
          oldItem[name] = '-1'
        }
      })
      return oldItem
    })

    props.itemsDiff.change.forEach((diff) => {
      itemsDiffMap.current.set(diff.id, diff.item)
    })
    props.itemsDiff.add.forEach((diff) => {
      itemsDiffMap.current.set(diff.id, diff.item)
    })

    const characterMap = new Map(props.characters.map((character) => [character.id, character.title]))
    const _newContractsCV = new wjCore.CollectionView(oldItems, {
      canAddNew: !props.isShopro && ['register', 'edit'].includes(props.mode),
      canRemove: !props.isShopro && ['register', 'edit'].includes(props.mode),
      calculatedFields: {
        rate: (obj) => obj.rate_decimal * 100,
        character_title: (obj) => characterMap.has(obj.character_id) ? characterMap.get(obj.character_id) : ''
      },
      groupDescriptions: ['parent']
    })

    _newContractsCV.collectionChanged.addHandler((cv, e) => {
      // 入力値をフィールドの型に変換
      if (e.item && e.item.royality) {
        e.item.royality = Math.floor(e.item.royality)
      }
      if (e.item && e.item.rate_decimal) {
        e.item.rate_decimal = Math.floor(e.item.rate_decimal * 10000) * 0.0001
      }
      // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
      jsonElem && jsonElem.val(JSON.stringify(_newContractsCV.items.filter((item) => item.character_id), inputFields))
    })
    // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
    jsonElem && jsonElem.val(JSON.stringify(_newContractsCV.items.filter((item) => item.character_id), inputFields))
    setNewContractsCV(_newContractsCV)

    const characters = [{ id: 0, title: '' }].concat(props.characters.map((character) => {
      if (character.is_default) {
        return null
      }
      return character
    }).filter((value) => value))

    const _layoutDef = getLayoutDef(
      props.mode,
      _newContractsCV,
      characters,
      props.rights,
      props.subCategories,
      props.isShopro,
      oldItems.some((contract) => contract.comment && contract.comment.length > 0)
    )
    setLayoutDef(_layoutDef)
  }, [])

  const addContract = (cv) => {
    const contractItem = {}

    contractItem.id = 0
    contractItem.character_id = 0
    contractItem.royality = 0
    contractItem.rate_decimal = 0
    contractItem.parent = 0

    const collection = [...cv.sourceCollection]
    collection.push(contractItem)
    cv.sourceCollection = collection
    cv.sortDescriptions.collectionChanged.raise(cv.sortDescriptions)
  }

  const gridInit = (grid) => {
    grid.tableFormat = tableFormat

    customContextMenu(grid)
    editableFlexGridInitialize(grid)

    grid.beginningEdit.addHandler((s, e) => {
    })

    grid.collectionView.collectionChanged.addHandler(() => {
      grid.refresh(true)
    })

    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        const contract = e.getRow().dataItem
        const column = grid.getBindingColumn(e.panel, e.row, e.col)
        // 申請修正時、変更箇所をマーキング
        const diff = itemsDiffMap.current.get(contract.id)
        if (diff) {
          let hasDiff = false
          if (column.binding === 'id') {
            hasDiff = false
          } else if (column.binding === 'rate_decimal') {
            hasDiff = 'rate' in diff
          } else {
            hasDiff = column.binding in diff
          }

          if (hasDiff) {
            wjCore.addClass(e.cell, 'wj-cell-alert')
          }
        }
      }
    })

    if (props.mode === 'register') {
      addContract(grid.collectionView)
    }
  }

  return (
    layoutDef && (
      <div className="d-inline-block w-100 text-center">
        <div className="d-inline-block mw-100">
          {diffExist && (
            <div className="text-left">
              <BootstrapAlert class="danger">
                <div>赤色で塗られた項目が変更箇所です。</div>
              </BootstrapAlert>
            </div>
          )}
          <div className="w-100 mb-2 text-left">
            {newContractsCV.canAddNew && (
              <button className="btn bg-theme-primary float-right my-1" type="button" onClick={() => addContract(newContractsCV)}>
                新規版権を追加
              </button>
            ) }
          </div>
          <wjMultiRow.MultiRow showMarquee={true} stickyHeaders={true} itemsSource={newContractsCV} layoutDefinition={layoutDef.def}
            keyActionTab={wjcGrid.KeyAction.Cycle} groupHeaderFormat="<b>クロスリクープ契約全体</b>"
            frozenColumns={layoutDef.frozenColumns} initialized={gridInit}
          >
          </wjMultiRow.MultiRow>
        </div>
      </div>
    )
  )
}

XrContractsRegisterGrid.propTypes = {
  characters: PropTypes.arrayOf(PropTypes.object),
  rights: PropTypes.arrayOf(PropTypes.object),
  subCategories: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.string,
  itemsJsonId: PropTypes.string,
  oldItemsJson: PropTypes.arrayOf(PropTypes.object),
  itemsDiff: PropTypes.object,
  isShopro: PropTypes.bool
}

XrContractsRegisterGrid.defaultProps = {
  rights: [],
  subCategories: [],
  itemsJsonId: '',
  oldItemsJson: [],
  itemsDiff: { add: [], change: [], delete: [] },
  isShopro: false
}

$('.xr-contracts-register-grid').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <XrContractsRegisterGrid {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
